var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.enabled !== false)?_c('div',{class:{
    section: true,
    'section-parking': true,
    [`section${_vm.orderNo}`]: true,
    topPadding: _vm.data.heading || _vm.data.description
  }},[_c('a',{staticClass:"navigation-target",attrs:{"id":_vm.hash,"href":"javascript:void(0);"}}),_vm._v(" "),(_vm.data.heading || _vm.data.description)?_c('div',{staticClass:"top-title"},[_c('AtomsCommonAtomTitle',{attrs:{"title":_vm.data.heading,"subtitle":_vm.data.description}})],1):_vm._e(),_vm._v(" "),_c('OrganismsCommonOrganismParkingAccess',{attrs:{"parking-access":_vm.data.items,"image-url":_vm.data.image}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }